<template>
  <div class="aha-textarea-wrapper">
    <textarea
      class="aha-textarea"
      :name="name"
      :placeholder="placeholder"
      :required="required"
      :maxlength="maxLength"
      :value="value"
      @input="$emit('input', $event.target.value)"
    />
    <div class="aha-textarea-limit" v-if="maxLength">
      {{ maxLength - (value ? value.length : 0) }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    maxLength: {
      default: null,
      type: Number,
    },
  },
}
</script>

<style lang="scss" scoped>
  .aha-textarea-wrapper {
    @apply relative;
  }
  .aha-textarea {
    @apply h-40 w-full my-2 p-3 block;
    @apply border border-base-30 border-solid rounded-md;
    @apply hover:border-primary-80 focus:border-primary-80 focus:outline-none;
    @apply focus:bg-primary-20 hover:bg-primary-20;
  }
  .aha-textarea-limit {
    @apply absolute bottom-2 right-2 text-secondary-40;
  }
</style>
